import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import "./contato.css";

const Contato = () => {
  const [formData, setFormData] = useState({ nome: "", email: "", mensagem: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    window.alert(
      "Obrigado pela mensagem! Para respostas rápidas, use o WhatsApp (42) 9 3300-8907 — nossa equipe responde em tempo real."
    );
    setFormData({ nome: "", email: "", mensagem: "" });
  };

  return (
    <div className="contato-page position-relative">
      <header className="contato-header text-center pt-4 mt-3" data-aos="fade-down">
        <p className="section-eyebrow mb-2">Atendimento 24h</p>
        <h1 className="display-5 fw-bold">Fale conosco</h1>
        <p className="lead text-muted">
          Estamos à disposição para reservas, dúvidas e um atendimento cordial em cada contato.
        </p>
      </header>

      <Container className="py-5">
        <Row className="g-4">
          <Col md={6} data-aos="fade-right">
            <Card className="h-100 border-0">
              <Card.Body>
                <h2 className="mb-4">Nossa localização</h2>
                <address className="mb-4 not-italic text-muted">
                  <p>
                    <FaMapMarkerAlt className="me-2 text-dark" aria-hidden />
                    <strong className="text-dark">Endereço:</strong> Rua Marechal Cândido Rondon, 2290
                    <br />
                    Centro, Laranjeiras do Sul - PR, 85301-060
                  </p>
                </address>
                <div className="map-container rounded overflow-hidden">
                  <iframe
                    title="Localização do Hotel"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.9497496332147!2d-52.413472999999996!3d-25.406492599999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94efcb063911391f%3A0xad0a802228408fd5!2sR.%20Mal.%20C%C3%A2ndido%20Rondon%2C%202290%20-%20%C3%81gua%20Verde%2C%20Laranjeiras%20do%20Sul%20-%20PR%2C%2085301-060!5e0!3m2!1spt-BR!2sbr!4v1731729272587!5m2!1spt-BR!2sbr"
                    width="100%"
                    height="350"
                    allowFullScreen
                    loading="lazy"
                    style={{ border: 0 }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} data-aos="fade-left">
            <Card className="h-100 border-0">
              <Card.Body>
                <h2 className="mb-4">Informações</h2>

                <p className="mb-3 text-muted">
                  <FaMapMarkerAlt className="me-2 text-dark" aria-hidden />
                  <strong className="text-dark">Endereço:</strong>
                  <br />
                  R. Mal. Cândido Rondon, 2290 – Água Verde
                  <br />
                  Laranjeiras do Sul – PR, 85301-060
                </p>

                <p className="mb-3">
                  <FaPhoneAlt className="me-2 text-dark" aria-hidden />
                  <strong>Recepção:</strong>{" "}
                  <a href="tel:+554236352720" className="text-decoration-none">
                    (42) 3635-2720
                  </a>
                </p>

                <p className="mb-3">
                  <FaWhatsapp className="me-2 text-dark" aria-hidden />
                  <strong>WhatsApp:</strong>{" "}
                  <a
                    href="https://wa.me/5542933008907"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    (42) 9 3300-8907
                  </a>
                </p>

                <p className="mb-3">
                  <FaEnvelope className="me-2 text-dark" aria-hidden />
                  <strong>E-mail:</strong>{" "}
                  <a href="mailto:reservashotelmarechal@hotmail.com" className="text-decoration-none">
                    reservashotelmarechal@hotmail.com
                  </a>
                </p>

                <p className="mb-3 text-muted">
                  <strong>Site:</strong>{" "}
                  <a href="https://www.hotelmarechal.com.br" target="_blank" rel="noopener noreferrer">
                    www.hotelmarechal.com.br
                  </a>
                </p>

                <p className="mb-4 text-muted">
                  <strong>Instagram:</strong>{" "}
                  <a href="https://www.instagram.com/hotelmarechalexpress" target="_blank" rel="noopener noreferrer">
                    @hotelmarechalexpress
                  </a>
                </p>

                <h3 className="h5 mt-4 mb-2 font-display">Horário</h3>
                <p className="text-muted mb-0">Recepção e atendimento <strong>24 horas</strong>, todos os dias.</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12} data-aos="fade-up">
            <Card className="border-0">
              <Card.Body>
                <h2 className="mb-2">Envie uma mensagem</h2>
                <p className="text-muted small mb-4">
                  Em breve integraremos o envio automático. Por enquanto, use o formulário para organizar sua mensagem e
                  confirme pelo WhatsApp.
                </p>
                <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                          type="text"
                          name="nome"
                          value={formData.nome}
                          onChange={handleChange}
                          required
                          placeholder="Seu nome completo"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="seuemail@exemplo.com"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Mensagem</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="mensagem"
                          rows={4}
                          value={formData.mensagem}
                          onChange={handleChange}
                          required
                          placeholder="Como podemos ajudar?"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="mt-4">
                    <Button variant="success" type="submit">
                      Enviar mensagem
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contato;
